import { Get, Post } from "services";
import { ApiPath } from "paths";

export const searchReservations = async (body) => {
  const res = await Post(`${ApiPath.SEARCH_RESERVATION}`, body);
  return res;
};

export const getReservationDetail = async ({ posReservationId, ...params }) => {
  const res = await Get(`${ApiPath.RESERVATION_ID(posReservationId)}`, params);
  return res;
};
